import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowRight = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 30,
	height: 29,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12.847 1.918L14.292.472a1.556 1.556 0 012.207 0l12.656 12.65a1.556 1.556 0 010 2.207L16.5 27.985a1.556 1.556 0 01-2.207 0l-1.445-1.445a1.564 1.564 0 01.026-2.233l7.845-7.474H2.007a1.559 1.559 0 01-1.563-1.562v-2.084c0-.866.697-1.562 1.563-1.562h18.71L12.874 4.15a1.553 1.553 0 01-.026-2.233z",
		fill: "currentColor"
	})
});
export default SvgIconArrowRight;
